import {
    ArrowLeftOutlined,
    ClockCircleOutlined,
    CheckCircleOutlined,
    CarOutlined,
    EnvironmentOutlined,
} from "@ant-design/icons";
import {
    Card,
    Divider,
    Flex,
    Space,
    Tag,
    Typography,
    List,
} from "antd";
import {
    doc,
    onSnapshot,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { db_fire } from "../firebase";
import moment from "moment";
import Loading from "../components/Loading";
import TakeawayTrackLocation from "../components/TakeawayTrackLocation";
import DeliveryTrackLocation from "../components/DeliveryTrackLocation";

const { Text, Title } = Typography;

const statusColor = {
    pending: "orange",
    assigned: "blue",
    picked: "purple",
    delivered: "green",
    cancelled: "red",
};

const statusIcon = {
    pending: <ClockCircleOutlined />,
    assigned: <CarOutlined />,
    picked: <CarOutlined />,
    delivered: <CheckCircleOutlined />,
};

export default function OrderDetails() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!id) return;

        const ref = doc(db_fire, "orders", id);

        const unsub = onSnapshot(
            ref,
            (snap) => {
                if (!snap.exists()) {
                    setOrder(null);
                    setLoading(false);
                    return;
                }
                setOrder({ _id: snap.id, ...snap.data() });
                setLoading(false);
            },
            (err) => {
                console.error("Order details error 👉", err);
                setLoading(false);
            }
        );

        return () => unsub();
    }, [id]);

    const getOrderStatus = o => {
        var s = o.adminStatus;
        if (o.deliveryStatus === "ACCEPTED") {
            s = "ASSIGNED"
        }

        if (o.deliveryStatus === "OUT_FOR_DELIVERY") {
            s = "OUT FOR DELIVERY"
        }
        return s
    }


    if (!order) {
        return navigate("/order", { replace: true })
    }
    console.log(order);
    

    return (
        <>
            {/* HEADER */}
            {loading && <Loading />}

            <Flex align="center" gap={10}>
                <ArrowLeftOutlined onClick={() => navigate(-1)} />
                <Title level={5} style={{ margin: 0 }}>
                    Order Details
                </Title>
            </Flex>

            <br />

            {/* STATUS */}
            <Card size="small">
                <Flex justify="space-between" align="center">
                <Text strong>Order No. <Text mark>{order?._id?.substring(0, 3)}</Text></Text> 
                    <Tag
                        color={statusColor[order.adminStatus]}
                        icon={statusIcon[order.adminStatus]}
                    >
                        {getOrderStatus(order)}
                    </Tag>
                </Flex>

                <Text type="secondary" style={{ fontSize: 12 }}>
                    Ordered on{" "}
                    {moment(order.createdAt?.toDate()).fromNow()}
                </Text>
            </Card>

            {/* <Divider /> */}
            <br />


            {/* DELIVERY ADDRESS */}
            {order.orderType === "delivery" && order.deliveryLocation && (
                <>
                    <Card size="small" title="Delivery Address">
                        <Space align="start">
                            <EnvironmentOutlined />
                            <Text>{order.deliveryLocation.address}</Text>
                        </Space>
                    </Card>
                    <br />
                </>
            )}

            {/* MAp location */}

            <Card size="small" title={`Track Location [${order.orderType.toUpperCase()}]`}>
                {
                    order.orderType === "takeaway"
                        ? <TakeawayTrackLocation />
                        : <DeliveryTrackLocation order={order} />
                }
            </Card> <br />

            {/* ITEMS */}
            <Card size="small" title="Items">
                <List
                    dataSource={order.items}
                    renderItem={(item) => (
                        <List.Item>
                            <Flex justify="space-between" style={{ width: "100%" }}>
                                <Text>
                                    {item.title} × {item.qty}
                                </Text>
                                <Text>₹ {item.price * item.qty}.00</Text>
                            </Flex>
                        </List.Item>
                    )}
                />
            </Card>

            <br />

            {/* BILL */}
            <Card size="small" title="Bill Summary">
                <Flex justify="space-between">
                    <Text>Items total</Text>
                    <Text>₹ {order.cartTotal}.00</Text>
                </Flex>

                {order.orderType !== "takeaway" && <Flex justify="space-between">
                    <Text>Delivery charges</Text>
                    <Text>
                        {order.deliveryCharge === 0
                            ? "FREE"
                            : `₹ ${order.deliveryCharge}.00`}
                    </Text>
                </Flex>}

                {order.couponDiscount > 0 && (
                    <Flex justify="space-between">
                        <Text>Coupon ({order?.couponCode})</Text>
                        <Text style={{ color: "green" }}>
                            − ₹ {order.couponDiscount}.00
                        </Text>
                    </Flex>
                )}
                {order.packagingCharges > 0 && (
                    <Flex justify="space-between">
                        <Text>Packaging charges</Text>
                        <Text>
                            ₹ {order.packagingCharges}.00
                        </Text>
                    </Flex>
                )}

                <br />

                <Flex justify="space-between">
                    <Text strong>Total Paid</Text>
                    <Text strong>₹ {order.finalAmount}.00</Text>
                </Flex>
            </Card>

            <Divider />

            {/* FOOTER */}
            <Text type="secondary" style={{ fontSize: 12 }}>
                Order ID: {order._id}
            </Text>
        </>
    );
}
